    <template>
            <div>
                <div class="flex w-full items-center justify-center h-screen">
                    <div class="sm:block w-1/2 bg-cover h-screen" style='background: url(password-rec-1.jpg)'>
                        <div class="bg-blue-800 w-full h-screen bg-opacity-20">
                        </div>
                    </div>
                    <div class="sm:w-1/2">
                        <div class="p-5 w-4/5 mx-auto text-left font-raleway">
                            <div class="text-left mb-10"> 
                                <router-link to="/login">
                                    <font-awesome-icon class="mr-5" :icon="['fas', 'arrow-left']" /> Login
                                </router-link> 
                            </div>
                            
                            <h1 class="font-bold text-left font-montserrat text-4xl sm:text-6xl mb-10">
                                Recover Your. eduBB. Password
                            </h1>
                            <p v-show="done" class="text-sm text-green-500">Passwort Reset-Link wurde an {{ email }} gesendet!</p>
                            <p v-show="error" class="text-sm text-red-500">Ein Fehler ist aufgetreten!</p>
                            <form @submit="forgotPassword">
                                <div class="my-5">
                                    <h1 class="text-left font-bold mb-5 font-montserrat">Email</h1>
                                    <input type="email" v-model="email" class="text-sm outline-none pb-5 w-4/5 bg-transparent border-b hover:border-blue-700 focus:border-blue-700">
                                </div>
                                
                                <button type="submit" class="bg-green-500 hover:bg-green-600 text-white font-bold py-1 px-4 rounded-full">
                                    Send Email link <font-awesome-icon class="ml-3" :icon="['fas', 'arrow-right']" /> 
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </template>

<script>
import axios from 'axios'

export default {
    name: 'ForgottenPassword',
    data() {
    return {
        email: "",
        error: null,
        done: null,
        API_URL:
        process.env.NODE_ENV == "production"
            ? process.env.VUE_APP_STRAPI_API_URL
            : "http://localhost:1338",
    };
  },
  methods: {
    async forgotPassword(e) {
      e.preventDefault()
      //const email = this.email

    
/*     const formatError = error => [
    { messages: [{ id: error.id, message: error.message, field: error.field }] },
    ]; */
    
    const email = this.email

    const data = {
        email
    }
/*       if (email > 0) {
      this.email = this.email.toLowerCase();
      console.log("is Email", this.email)
    } else {
        formatError({
          id: 'Auth.form.error.email.format',
          message: 'Please provide a valid email address.',
        })
    } */
      
      //console.log("email", email)


       await axios({
        method: 'POST',
        url: `${this.API_URL}`+ `/auth/forgot-password`,
        data
      }).then( (response) => {
        // Handle Success
        this.done = true
        console.log('Your user received an email', response);
        //console.log("ForgottenPassword.submit userCreationRes", userPasswordRes)
      }).catch(error => {
        // Handle error
        this.error = true
        console.log('An error', error)
      })


      // THis ist with Firebase Auth
/*       createUserWithEmailAndPassword(this.form.email, this.form.password)
        .then((data) => {
          data.user
            .updateProfile({
              displayName: this.form.name,
            })
            .then(() => {});
        })
        .catch((err) => {
          this.error = err.message;
        }); */


    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css");
body {
  font-family: "Lato", sans-serif;
}
.checkbox:checked {
  border: none;
}
.checkbox:checked + .check-icon {
  display: flex;
}
.color-blue {
  color: #0047ab;
}
</style>
